<template>
  <Dialog
    :header="
      !formData.id ? 'Cadastro de Tipo de Usuário' : 'Edição de Tipo de Usuário'
    "
    :visible="visible"
    :modal="true"
    :closable="false"
    @update:visible="$emit('update:visible', $event)"
    style="width: 800px"
  >
    <AppForm
      ref="form"
      :rules="rules"
      :values="formData"
      v-slot:default="{ formErrors }"
    >
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12">
          <AppFormItem :error="formErrors.name" label="Nome">
            <InputText v-model="formData.name" />
          </AppFormItem>
        </div>
        <div class="p-field p-col-12">
          <AppFormItem label="Descrição">
            <Textarea v-model="formData.description" rows="1" />
          </AppFormItem>
        </div>
        <div class="p-field p-col-12">
          <div class="p-text-bold">Permissões de Leitura</div>
        </div>
        <div
          class="p-col-2"
          v-for="(item, index) in formData.permissions.read"
          :key="index"
        >
          <div class="p-field-checkbox">
            <Checkbox
              :name="item.subject"
              :binary="true"
              v-model="item.checked"
              @input="onCheck('read', item)"
            />
            <label :for="item.subject"> {{ item.name }} </label>
          </div>
        </div>
        <div class="p-field p-col-12">
          <div class="p-text-bold">Permissões de Escrita</div>
        </div>
        <div
          class="p-col-2"
          v-for="(item, index) in formData.permissions.write"
          :key="index"
        >
          <div class="p-field-checkbox">
            <Checkbox v-if="item.subject === 'Home'" :disabled="true" />
            <Checkbox
              v-else
              :name="item.subject"
              :binary="true"
              v-model="item.checked"
              @input="onCheck('write', item)"
            />
            <label :for="item.subject"> {{ item.name }} </label>
          </div>
        </div>
        <div class="p-field p-col-12">
          <div class="p-text-bold">Permissões de Deleção</div>
        </div>
        <div
          class="p-col-2"
          v-for="(item, index) in formData.permissions.delete"
          :key="index"
        >
          <div class="p-field-checkbox">
            <Checkbox v-if="item.subject === 'Home'" :disabled="true" />
            <Checkbox
              v-else
              :name="item.subject"
              :binary="true"
              v-model="item.checked"
              @input="onCheck('delete', item)"
            />
            <label :for="item.subject"> {{ item.name }} </label>
          </div>
        </div>
      </div>
    </AppForm>
    <template #footer>
      <div class="p-grid p-jc-end">
        <div style="padding-right: 8px">
          <Button
            label="Cancelar"
            class="p-button-outlined p-mr-2"
            @click="cancel()"
          />
          <AppButton label="Salvar" @click="save()" :loading="loadingSave" />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script>
import { APP_SUBJECTS } from '../../lib/permissions';
import { UserTypeApi } from '../../services/api';

const defaultData = () => {
  const getSubjects = () =>
    [...APP_SUBJECTS].map((sub) => ({ ...sub, checked: false }));
  return {
    id: null,
    name: '',
    description: '',
    permissions: {
      read: getSubjects(),
      write: getSubjects(),
      delete: getSubjects(),
    },
  };
};

export default {
  name: 'UserTypeEdit',
  props: {
    visible: Boolean,
  },
  data() {
    return {
      APP_SUBJECTS,
      formData: {
        ...defaultData(),
      },
      loadingSave: false,
      rules: {
        name: [{ required: true, message: 'Informe o nome.' }],
      },
    };
  },
  async created() {},
  methods: {
    setData(data) {
      if (!data) {
        return;
      }
      this.$nextTick(() => {
        const { permissions } = defaultData();

        ['read', 'write', 'delete'].forEach((action) => {
          permissions[action] = permissions[action].map((permission) => {
            const checked = data.permissions.some(
              (p) => p.action === action && p.subject === permission.subject
            );
            return {
              ...permission,
              checked,
            };
          });
        });

        this.formData = {
          ...data,
          permissions,
        };
      });
    },
    reset() {
      this.formData = { ...defaultData() };
    },
    cancel() {
      this.$emit('update:visible', false);
      this.reset();
    },
    onCheck(action, item) {
      const setChecked = (subject, checked = true) => {
        return (p) => {
          if (p.subject === subject) {
            return { ...p, checked };
          }
          return p;
        };
      };

      if (action === 'write' && item.checked) {
        this.formData.permissions.read = this.formData.permissions.read.map(
          setChecked(item.subject, true)
        );
      }
      if (action === 'delete' && item.checked) {
        this.formData.permissions.read = this.formData.permissions.read.map(
          setChecked(item.subject, true)
        );
        this.formData.permissions.write = this.formData.permissions.write.map(
          setChecked(item.subject, true)
        );
      }

      if (action === 'read' && !item.checked) {
        this.formData.permissions.write = this.formData.permissions.write.map(
          setChecked(item.subject, false)
        );
        this.formData.permissions.delete = this.formData.permissions.delete.map(
          setChecked(item.subject, false)
        );
      }
      if (action === 'write' && !item.checked) {
        this.formData.permissions.delete = this.formData.permissions.delete.map(
          setChecked(item.subject, false)
        );
      }
    },
    async save() {
      try {
        if (!(await this.$refs.form.validate())) {
          return;
        }
        this.loadingSave = true;
        const formatPermission = (items, action) =>
          items
            .filter((item) => item.checked)
            .map((item) => ({ subject: item.subject, action }));

        const body = {
          ...this.formData,
          permissions: [
            ...formatPermission(this.formData.permissions.read, 'read'),
            ...formatPermission(this.formData.permissions.write, 'write'),
            ...formatPermission(this.formData.permissions.delete, 'delete'),
          ],
        };

        if (!this.formData.id) {
          await UserTypeApi.create(body);
        } else {
          await UserTypeApi.update(this.formData.id, body);
        }

        this.$emit('update:visible', false);
        this.$emit('saved', body);
        this.reset();
      } catch (error) {
        this.handleError(error);
      } finally {
        this.loadingSave = false;
      }
    },
    handleError(error) {
      console.log(error);
      const detail = 'Não foi possível salvar o tipo de usuário.';
      this.$toast.add({
        severity: 'error',
        summary: 'Desculpe! Não é possível salvar.',
        detail,
        life: 3000,
      });
    },
  },
};
</script>

<style scoped>
</style>
